import { css } from "@emotion/react"
import { above } from "@mkt/cp/src/styles/Breakpoints"
import { container } from "@mkt/cp/src/styles/Functions"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"

export const hold = css`
  ${container};
  padding: 0;
  display: flex;
  flex-direction: column;

  ${above["m"]} {
    padding: 0 24px;
    display: grid;
    grid-template-columns: 50% 50%;
  }

  ${above["l"]} {
    grid-template-columns: 58% 42%;
  }
`
export const content = css`
  padding: 32px 24px 0;

  ${above["m"]} {
    padding: 48px 48px 0 0;
  }
`
export const disclaimer = css`
  margin-bottom: 24px;
  line-height: 22px;
  list-style: none;
  font-family: "Source Sans Pro";
  font-size: 16px;
  color: ${colorsCP["gray-60"]};
`
export const aside = css`
  width: 100%;

  ${above["m"]} {
    padding-top: 48px;
  }

  ${above["l"]} {
    min-width: 450px;
    max-width: 35vw;
  }
`
export const form = css`
  background-color: white;
  width: 100%;
  border-radius: 0;
  padding: 32px 24px;

  ${above["m"]} {
    border-radius: 16px;
    padding: 32px;
    border-radius: 16px;
    position: sticky;
    position: -webkit-sticky;
    top: 130px;
  }

  .iq-field-base {
    &__label{
      color: ${colorsCP["neutral-50"]};
    }

    &__required {
      color: ${colorsCP["error-40"]};
    }
  }
`
export const faq = css`
  margin-top: 64px;
  padding-block: 64px;
  background-color: ${colorsCP["gray-0"]};
`
export const faqHold = css`
  ${container};

  ${above["m"]} {
    max-width: 725px;
  }
`
